import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
 
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { 
  CreateWatchlistForm, 
  AccountSelectionTabs 
} from '@/components/watchlists'
import { watchlistService } from '@/services'
import { useToast } from '@/hooks'

 

export function CreateWatchlistPage() {
  const navigate = useNavigate()
  const { toast } = useToast()
  const [selectedAccounts, setSelectedAccounts] = useState<string[]>([])
  const [isCreating, setIsCreating] = useState(false)

  const handleAccountToggle = (accountId: string) => {
    setSelectedAccounts(prev => 
      prev.includes(accountId)
        ? prev.filter(id => id !== accountId)
        : [...prev, accountId]
    )
  }

  const handleCreateWatchlist = async (name: string, description: string) => {
    if (selectedAccounts.length === 0) return
    
    setIsCreating(true)
    
    try {
      // Create watchlist with selected accounts
      const response = await watchlistService.createWatchlist({
        name: name.trim(),
        description: description.trim() || undefined,
        account_uuids: selectedAccounts
      })
      
      if (response.success) {
        // Redirect to the new watchlist page
        navigate(`/instagram/watchlist/${response.watchlist_id}`)
      } else {
        throw new Error(response.message || 'Failed to create watchlist')
      }
    } catch (error) {
      console.error('Failed to create watchlist:', error)
      setIsCreating(false)
      toast({
        title: "Error",
        description: `Failed to create watchlist: ${error instanceof Error ? error.message : 'Unknown error'}`,
        variant: "destructive",
      })
    }
  }

  const handleBack = () => {
    navigate('/watchlists')
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Button variant="outline" size="sm" onClick={handleBack}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Watchlists
        </Button>
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Create New Watchlist</h1>
          <p className="text-muted-foreground">Select accounts and name your watchlist</p>
        </div>
      </div>

      {/* Account Selection */}
      <AccountSelectionTabs 
        selectedAccounts={selectedAccounts}
        onAccountToggle={handleAccountToggle}
      />

      {/* Watchlist Form */}
      <CreateWatchlistForm 
        onSubmit={handleCreateWatchlist}
        selectedAccountsCount={selectedAccounts.length}
        isLoading={isCreating}
      />
    </div>
  )
} 